import axios from 'axios';
import { API_URL } from '../config/api.config';

// Le token est relu à chaque requête (il peut changer après un refresh)
const authAxios = axios.create({ baseURL: API_URL });
authAxios.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.set('Authorization', `Bearer ${token}`);
    }
    // Pas d'autorisation sur ces routes pour l'instant (chantier JWT à part) : le garage est identifié par son id
    try {
        const garageId = JSON.parse(localStorage.getItem('user') || '{}')._id;
        if (garageId) config.params = { ...(config.params || {}), garageId };
    } catch { /* identité absente */ }
    return config;
});

export const appointmentService = {
    async createAppointment(data: any) {
        const response = await authAxios.post('/inspections/appointments', data);
        return response.data;
    },
    async getAppointments(params?: any) {
        const response = await authAxios.get('/inspections/appointments', { params });
        return response.data;
    },
    async getAppointmentById(appointmentId: string) {
        const response = await authAxios.get(`/inspections/appointments/${appointmentId}`);
        return response.data;
    },
    async updateStatus(appointmentId: string, data: any) {
        const response = await authAxios.put(`/inspections/appointments/${appointmentId}/status`, data);
        return response.data;
    },
    async reschedule(appointmentId: string, data: any) {
        const response = await authAxios.put(`/inspections/appointments/${appointmentId}/reschedule`, data);
        return response.data;
    },
    async getAvailableSlots(date: string, duration?: number) {
        const response = await authAxios.get('/inspections/appointments/slots', { params: { date, duration } });
        return response.data;
    },
    // Réponse du garage à une demande ou contre-proposition du client
    async respond(appointmentId: string, payload: { action: 'ACCEPT' | 'REFUSE' | 'COUNTER'; date?: string; timeSlot?: string; reason?: string; note?: string }) {
        const response = await authAxios.post(`/inspections/appointments/${appointmentId}/respond`, payload);
        return response.data;
    },
    async getStats(params?: { from?: string; to?: string }) {
        const response = await authAxios.get('/inspections/appointments/stats', { params });
        return response.data;
    },
    // Créneaux libres suggérés pour « Proposer plutôt »
    async getSuggestions(appointmentId: string, count = 3) {
        const response = await authAxios.get(`/inspections/appointments/${appointmentId}/suggestions`, { params: { count } });
        return response.data;
    },
    async getConfig() {
        const response = await authAxios.get('/inspections/appointments/config');
        return response.data;
    },
    async updateConfig(data: any) {
        const response = await authAxios.put('/inspections/appointments/config', data);
        return response.data;
    }
};
